//IE
var ua = navigator.userAgent.toLowerCase();
var ver = navigator.appVersion.toLowerCase();
// IE(11以外)
var isMSIE = (ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);
// IE11
var isIE11 = (ua.indexOf('trident/7') > -1);
// Edge
var isEdge = (ua.indexOf('edge') > -1);
// IE
var isIEnotEdge = isMSIE || isIE11;
var isAllIE = isMSIE || isIE11 || isEdge;
if(isIEnotEdge) {
  $("body").addClass('ieStyle')
} else if(isEdge) {
  $("body").addClass('edgeStyle')
}

//INVIEW
$('.js-inview').on('inview', function(event, isInView) {
	if(isInView){
		$(this).stop().addClass('animation');
	}
});

//kv_slider
var kvSlide = function ($element) {
	//変数宣言
	var $children = $element.children(),
			current = 0,
			time = 5000; //切り替えの早さ
	//1番目の要素に、current追加
	$children.eq(current).addClass('current');
	//順番に、current追加（current += 1）。子要素（$children）の数と、current - 1 の数が等しくなったら、currentは0に戻る
	setInterval(function () {
		$children.eq(current).removeClass('current');
		current = current === $children.length - 1 ? 0 : current += 1;
		$children.eq(current).addClass('current');
	}, time);
};
//2枚以上なら実行
if($('#kv_bgi li').length > 1){
	kvSlide($('#kv_bgi'));
}